import { request } from "../httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchKpisBySiteIdAtTime({ queryKey }) {
  const [, siteId, at_time, timeout] = queryKey;
  const url = `${getUrl("getKpisUrl")}${siteId}?at_time=${encodeURIComponent(at_time)}`;
  return request(url, {}, timeout);
}
